import React from 'react';
// @ts-ignore
import styles from './SecretButton.module.scss';
interface Props {
	onClick: () => void;
}
const SecretButton: React.FC<Props> = ({ onClick }) => {
	return <div className={styles.button} onClick={onClick} />;
};

export default SecretButton;
